// removed by extract-text-webpack-plugin
module.exports = {"content":"ResetPasswordSend__content__17VN2","parentContainer":"ResetPasswordSend__parentContainer__1AoSa","loginForm":"ResetPasswordSend__loginForm__1k-AP"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/ResetPasswordSend/ResetPasswordSend.css
// module id = 1022
// module chunks = 0